import React from "react";
import styled from "styled-components";
import { onDominant } from "@glossy/theme";
import Dropdown from "@komon/dropdown";
import DropdownMenu from "@komon/dropdown/menu";
import DropdownToggle from "@komon/dropdown/toggle";

const StyledDropdown = styled(Dropdown)`
  white-space: nowrap;
  box-sizing: border-box;
  cursor: pointer;
  color: ${onDominant};
  align-self: stretch;
  display: flex;
  align-items: center;
`;

const StyledDropdownToggle = styled(DropdownToggle)`
  position: relative;
  display: initial;
`;

const StyledDropdownMenu = styled(DropdownMenu)`
  top: calc(100% - 5px);
`;

interface IProps {
  toggle: React.ReactNode;
  menu: React.ReactNode;
  pullRight?: boolean;
}

const KomonNavigationNavbarDropdown = ({ toggle, pullRight, menu }: IProps) => (
  <StyledDropdown pullRight={pullRight}>
    <StyledDropdownToggle>{toggle}</StyledDropdownToggle>
    <StyledDropdownMenu pullRight={pullRight}>{menu}</StyledDropdownMenu>
  </StyledDropdown>
);

export default KomonNavigationNavbarDropdown;
